const searchBtn = document.querySelectorAll(".header__search-icon");
const searchPage = document.querySelector(".search__full-width");
const closeSearch = document.querySelector(".search-close");

searchBtn.forEach((btn) => {
	
	btn.addEventListener("click", () => {

		// btn.toggleAttribute("data-expanded");
		searchPage.classList.add("search-open");
	});
});

closeSearch.addEventListener("click", () => {
		// btn.toggleAttribute("data-expanded");
		searchPage.classList.remove("search-open");
});


const searchBtnMobile = document.querySelectorAll(".header__search-icon--mobile");
const searchPageMobile = document.querySelector(".search__full-width--mobile");
const closeSearchMobile = document.querySelector(".search-close--mobile");

searchBtnMobile.forEach((btn) => {
	
	btn.addEventListener("click", () => {

		// btn.toggleAttribute("data-expanded");
		searchPageMobile.classList.add("search-open");
	});
});
if(closeSearchMobile){
	closeSearchMobile.addEventListener("click", () => {
		// btn.toggleAttribute("data-expanded");
		searchPageMobile.classList.remove("search-open");
});
}
